export default __webpack_public_path__ + "static/media/20210715cut.a2092783.mp4";